<template>

  <v-card variant="elevated">
    <v-card-title>
      <v-container class="ml-n1">
        <v-row justify="start">
          <v-col class="w-75">
             SAML
             &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
             &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            <span v-if="metadataExists" class="metadata">
              <a target="_blank" :href="metadata.metadataUrl">Download SAML Metadata</a>
            </span>
            <span v-else class="metadata">
              Download SAML Metadata
            </span>
          </v-col>
        </v-row>
      </v-container>
    </v-card-title>
    <v-card-text>
      <v-form v-model="valid" ref="form" @submit.prevent>
      <v-container class="ml-n1">

        <v-row justify="start">
          <v-col class="w-75">
            <v-text-field label="Service Provider Entity ID" variant="outlined"
                          v-model="metadata.spEntityId" readonly
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="start">
          <v-col class="w-75">
            <v-text-field label="Assertion Consumer Service URL" variant="outlined"
                          v-model="metadata.acsUrl" readonly
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="start">
          <v-col class="w-75">
            <v-text-field label="Single Sign-On URL" variant="outlined"
                          v-model="metadata.loginUrl" :rules="rules.required"></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="start">
          <v-col class="w-75">
            <v-text-field label="Single Sign-Out URL (optional)" variant="outlined"
                          v-model="metadata.logoutUrl"></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="start">
          <v-col class="w-25">
            <v-text-field label="Issuer (IDP Entity ID)" variant="outlined"
                          v-model="metadata.entityId" :rules="rules.required"></v-text-field>
          </v-col>
          <v-col class="w-75">
            <v-select
                label="NameID policy format"
                v-model="metadata.nameIdFormat"
                :items="nameIdFormatItems"
                :rules="rules.required"
                item-text="k"
                item-value="v"
                class="w-75"
            ></v-select>
          </v-col>
        </v-row>

        <v-row justify="start">
          <v-col class="w-25">
            <v-radio-group v-model="metadata.loginBinding" inline :rules="rules.required">
              <v-radio label="HTTP-POST" value="urn:oasis:names:tc:SAML:2.0:bindings:HTTP-POST"></v-radio>
              <v-radio label="HTTP-Redirect" value="urn:oasis:names:tc:SAML:2.0:bindings:HTTP-Redirect"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col class="w-25">
            <v-checkbox label="Sign SAML Request" v-model="metadata.signAuthnRequest"></v-checkbox>
          </v-col>
          <v-col class="w-50">
            <v-select
                label="Signature Algorithm"
                v-model="metadata.signingAlgorithm"
                :items="signingAlgorithmItems"
                :rules="rules.required"
                item-text="k"
                item-value="v"
                class="w-75"
            ></v-select>
          </v-col>
        </v-row>

        <v-row justify="start">
          <v-col>
            <v-textarea label="Verification / Validation Certificate" variant="outlined"
                        v-model="metadata.verificationCert" :rules="rules.required"
                        class="cert-mono"
                        clearable clear-icon="mdi-close-circle"></v-textarea>
          </v-col>
        </v-row>

        <v-row justify="start">
          <v-col>
            <v-text-field label="Admin Group Mapping" variant="outlined"
                          placeholder="vyopta_admin"
                          v-model="metadata.adminRoleMapping"></v-text-field>
          </v-col>
          <v-col>
            <v-text-field label="User Group Mapping" variant="outlined"
                          placeholder="vyopta_vanrptvwr"
                          v-model="metadata.userRoleMapping"></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="start">
          <v-col>
            <v-text-field label="Dashboard Group Mapping" variant="outlined"
                          placeholder="vyopta_vanDbVwr"
                          v-model="metadata.dashboardRoleMapping"></v-text-field>
          </v-col>
          <v-col>
            <v-text-field label="Read-only Group Mapping" variant="outlined"
                          placeholder="vyopta_vanRptRdr"
                          v-model="metadata.readOnlyRoleMapping"></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="start" v-if="showDomainAlias">
          <v-col class="w-25">
            <v-text-field label="Domain Aliases" variant="outlined"
                          v-model="metadata.domainAliases"></v-text-field>
          </v-col>
          <v-col class="w-25">
          </v-col>
        </v-row>

      </v-container>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <button class="me-4 btn btn-primary" @click="save" :disabled="!valid">Save</button>
      <button class="me-4 btn btn-default" @click="cancel">Cancel</button>
      <button class="me-4 btn btn-default" @click="deleteMetadata">Delete</button>
    </v-card-actions>
  </v-card>

</template>
<style>
.cert-mono textarea {
  font-family: monospace;
}
.metadata {
  font-size: 14px;
}
</style>
<script>
import {mapGetters} from "vuex";
export default {
  data() {
    return {
      valid: false,
      metadata: {
        exists: false,
        registrationId: '',
        loginUrl: '',
        loginBinding: '',
        logoutUrl: '',
        entityId: '',
        nameIdFormat: '',
        signAuthnRequest: false,
        signingAlgorithm: 'http://www.w3.org/2001/04/xmldsig-more#rsa-sha256',
        verificationCert: '',
        adminRoleMapping: '',
        userRoleMapping: '',
        dashboardRoleMapping: '',
        readOnlyRoleMapping: '',
        acsUrl: '',
        metadataUrl: '',
        spEntityId: '',
        domainAliases: ''
      },
      nameIdFormatItems: [
        {k: 'Persistent', v: 'urn:oasis:names:tc:SAML:2.0:nameid-format:persistent'},
        {k: 'Transient', v: 'urn:oasis:names:tc:SAML:2.0:nameid-format:transient'},
        {k: 'Email Address', v: 'urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress'},
        {k: 'Unspecified', v: 'urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified'}
      ],
      signingAlgorithmItems: [
        {k: 'RSA-SHA256', v: 'http://www.w3.org/2001/04/xmldsig-more#rsa-sha256'},
        {k: 'RSA-SHA512', v: 'http://www.w3.org/2001/04/xmldsig-more#rsa-sha512'}
      ],
      // https://rmirabelle.medium.com/fixing-vuetifys-form-validation-3a5781ea43fe
      rules: {
      },
    };
  },
  methods: {
    async refresh() {
      this.rules = {}
      this.loading = true;
      this.metadata = await this.$store.dispatch("singleSignOn/getSamlMetadata");
      this.loading = false;
    },
    async cancel() {
      await this.refresh();
    },
    async save() {
      // replace empty rules with real rules
      this.rules = {
        required: [(value) => !!value || "Required."]
      }
      // let the DOM update
      await this.$nextTick();
      // manually trigger Vuetify validation
      if(this.$refs.form.validate()) {
        // form is valid, save metadata
        await this.$store.dispatch("singleSignOn/createSamlMetadata", {metadata: this.metadata});
        await this.refresh();
      }
    },
    async deleteMetadata() {
      if (confirm('Do you wish to delete the SAML metadata?')) {
        await this.$store.dispatch('singleSignOn/deleteSamlMetadata');
        await this.refresh();
      }
    },
  },
  computed: {
    ...mapGetters("user", {
      orgContext: "getOrgContext",
      isSU: 'isSU'
    }),
    metadataExists: function() {
      return this.metadata.exists;
    },
    showDomainAlias: function() {
      return this.isSU;
    }
  },
  watch: {
    orgContext: function (val) {
      if (!val) {
        return;
      }
      this.refresh()
    }
  },
  async created() {
    await this.refresh();
  }
};
</script>
